import "./Onboarding.scss";
import React, { useContext, useEffect, useState } from "react";
import language from "../../util/en";
import ProgressSteps from "../shared/FormComponents/ProgressSteps/ProgressSteps";
import CreateAccount from "./Content/CreateAccount/CreateAccount";
import UseSandbox from "./Content/UseSandbox/UseSandbox";
import RequestLive from "./Content/RequestLive/RequestLive";
import { Route, Switch, useHistory, useRouteMatch } from "react-router";
import { authContext } from "../../provider/Context/AuthContext";
import { EAccountStatus } from "../../common/enum/EAccountStatus";
import ActivateAndLaunch from "./Content/ActivateAndLaunch/ActivateAndLaunch";
import UserDetails from "../../common/model/UserDetails";
import { userContext } from "../../provider/Context/UserContext";
import { userDetailsLocalStorageKey } from "../../common/constant";
import DIContainer from "../../config/di.container";
import LocalStorageService from "../../services/local.storage.service";
import DITYPES from "../../config/di.types";
import LoggedInUserInfo from "../../common/model/LoggedInUserInfo";
import SnackbarContext from "../../provider/Context/SnackbarContext";
import Snackbar from "../../components/shared/Snackbar/Snackbar";
import {EComponentName} from "../../common/enum/EComponentName";

const localStorageService = DIContainer.get<LocalStorageService>(DITYPES.LocalstorageService);
const Onboarding: React.FC = () => {

  const [createAccountProgress, setCreateAccountProgress] = useState(0);
  const [useSandboxProgress, setUseSandboxProgress] = useState(0);
  const [requestLiveProgress, setRequestLiveProgress] = useState(0);
  const [activeLaunchProgress, setActiveLaunchProgress] = useState(-1);
  const auth = useContext(authContext);
  const { setAuthData } = useContext(authContext);
  const userDetails = useContext(userContext);
  const snackbarContextObj = useContext(SnackbarContext);

  let user = new UserDetails();
  const handleSubmit = (formsubmited: string, value = 100) => {

    var loggedUser = new LoggedInUserInfo();
    loggedUser.isLoggedIn = true;

    switch (formsubmited.toLowerCase()) {
      case "createaccount":
        setCreateAccountProgress(value);
        loggedUser.status = EAccountStatus.Sandbox;
        setAuthData(loggedUser);
        history.push(`${path}/use-sandbox`);
        return;
      case "usesandbox":
        setUseSandboxProgress(value);
        history.push(`${path}/request-live`);
        return;
      case "goliveform":
        setRequestLiveProgress(value);
        loggedUser.status = EAccountStatus.ApplicationPending;
        setAuthData(loggedUser);
        history.push(`${path}/use-sandbox`);
        return;
      default:
        return;
    }
  };
  const history = useHistory();

  let { path } = useRouteMatch();
  const handleOnChange = (formProgessChanged: string, value = 100) => {

    switch (formProgessChanged) {
      case "createAccount":
        setCreateAccountProgress(value);
        return;
      case "usesandbox":
        setUseSandboxProgress(value);
        return;
      case "GoLiveForm":
        setRequestLiveProgress(value);
        return;
      case "ActivateAndLaunchForm":
        setActiveLaunchProgress(value);
        return;
      default:
        return;
    }
  };

  var userDetail: UserDetails = new UserDetails();
  useEffect(() => {
    loadChild();

    Object.assign(userDetails, JSON.parse(localStorageService.get(userDetailsLocalStorageKey) || '{}'));

  }, [history.location.pathname, auth.status, userDetails.user])

  const loadChild = () => {
    let location = history.location.pathname;
    let statusValue = auth?.status?.valueOf();

    if (auth.loggedIn && statusValue == EAccountStatus.NotMentioned.valueOf() || (!auth?.status || statusValue == EAccountStatus.NotMentioned.valueOf()) && (location == "/ui/onboarding/create-account" || location == "/ui/onboarding")) {
      history.push(`${path}/create-account`);
    }
    else if ((statusValue == EAccountStatus.Sandbox.valueOf() && (useSandboxProgress < 100 ||
      location == "/ui/onboarding/use-sandbox")) || statusValue == EAccountStatus.ApplicationPending.valueOf()) {
      //If status is ApplicationPending then Set Request Go live progress to 100//
      if (statusValue == EAccountStatus.ApplicationPending.valueOf()) {
        setRequestLiveProgress(100);
      }
      setCreateAccountProgress(100);
      history.push(`${path}/use-sandbox`);
    }
    else if (statusValue == EAccountStatus.Sandbox.valueOf() || (statusValue == EAccountStatus.Sandbox.valueOf() && location == "/ui/onboarding/request-live")) {
      var tempUser = localStorageService.get(userDetailsLocalStorageKey);
      if (tempUser) {
        Object.assign(user, JSON.parse(tempUser));
      }
      setCreateAccountProgress(100);
      setUseSandboxProgress(100);
      history.push(`${path}/request-live`);
    }
    else if (statusValue == EAccountStatus.Approved.valueOf() || (statusValue == EAccountStatus.Approved.valueOf() && location == "/ui/onboarding/activate-launch" || location == "/ui/onboarding")) {
      setCreateAccountProgress(100);
      setUseSandboxProgress(100);
      setRequestLiveProgress(100);
      history.push(`${path}/activate-launch`);
    }
  }


  return (
    <div className="onboarding-div" >
      <div className="sub-header">
        <span className="alignment d-flex justify-content-between">
          <ProgressSteps
            title={language.onboarding.CreateAccount}
            value={createAccountProgress}
          />
          <ProgressSteps
            title={language.onboarding.UseSandbox}
            value={useSandboxProgress}
          />
          <ProgressSteps
            title={language.onboarding.RequestLive}
            value={requestLiveProgress}
          />
          <ProgressSteps
            title={language.onboarding.ActivateLaunch}
            value={activeLaunchProgress}
          />
        </span>
      </div>
      { snackbarContextObj.name == EComponentName.onboarding &&
        <div className="ob-snackbar-container">
          <Snackbar></Snackbar>
        </div>
      }
      <div className={(history.location.pathname != "/ui/onboarding/use-sandbox" ? "ob-child-route-div" : "")} >
        <Switch>
          <Route path={`${path}/create-account`} render={() => <CreateAccount handleSubmit={handleSubmit} handleOnChange={handleOnChange} />} />
          <Route path={`${path}/use-sandbox`} render={() => <UseSandbox email={userDetails?.user?.Email} businessName={userDetails?.user?.BusinessName} handleOnChange={handleOnChange} isApplicationPending={(auth?.status?.valueOf() == EAccountStatus.ApplicationPending.valueOf())} handleSubmit={handleSubmit} />} />
          <Route path={`${path}/request-live`} render={() => <RequestLive handleOnChange={handleOnChange} handleSubmit={handleSubmit} />} />
          <Route path={`${path}/activate-launch`} render={() => <ActivateAndLaunch userDetails={userDetail} handleOnChange={handleOnChange} />} />
        </Switch>
      </div>
    </div>
  );
};

export default Onboarding;
